import { MinzeElement } from "minze";

export interface TjSelectArrowIcon {}

export class TjSelectArrowIcon extends MinzeElement {
  html = () => `
    <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M5 8.33366L0 1.66699H10L5 8.33366Z" fill="#133762"/>
    </svg>
  `;

  css = () => `
    
  `;
}
